import { ResourceEnum } from "src/constants/constants.ts";
import { useResourceFormResource } from "src/components/Form/hooks/useResourceFormResource.ts";
import { Price as ProductPrice } from "src/components/Form/panels/PricePanel/components/product/Price.tsx";
import { Price as VariantPrice } from "src/components/Form/panels/PricePanel/components/variant/Price.tsx";
import { Price as VariantComponentPrice } from "src/components/Form/panels/PricePanel/components/variant-component/Price.tsx";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";

await loadTranslations(TranslationNamespaceEnum.PricePanel);

export const PricePanel = () => {
  const resource = useResourceFormResource();
  if (resource === ResourceEnum.Product) {
    return <ProductPrice />;
  }
  if (resource === ResourceEnum.Variant) {
    return <VariantPrice />;
  }
  if (resource === ResourceEnum.VariantComponent) {
    return <VariantComponentPrice />;
  }
  return null;
};
